// React
import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";

// Hooks
import { useTranslation } from "../../hooks/useTranslation";

// Assets
import specialDiscountImg from "../../assets/images/pricelist/special_discount.jpg";
import specialDiscountImg2 from "../../assets/images/pricelist/special_discount_2.jpg";

export default function SpecialDiscount(promps) {
    const [open, setOpen] = useState(false);
    const [activeImg, setActiveImg] = useState(specialDiscountImg);
    const closeBtnRef = useRef(null);
    const t = useTranslation();

    const fadeUp = (i = 0) => ({
        hidden: { opacity: 0, y: 40 },
        show: {
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.05, duration: 0.4 }
        }
    });

    const handleOpenImage = (img) => {
        setActiveImg(img);
        setOpen(true);
    };

    useEffect(() => {
        const onEsc = (e) => e.key === "Escape" && setOpen(false);
        window.addEventListener("keyup", onEsc);
        return () => window.removeEventListener("keyup", onEsc);
    }, []);

    useEffect(() => {
        if (open) {
            closeBtnRef.current?.focus();
        }
    }, [open]);

    const modal =
        open &&
        createPortal(
            <div
                className="gdv-modal"
                role="dialog"
                aria-modal="true"
                onClick={() => setOpen(false)}
            >
                <button
                    ref={closeBtnRef}
                    aria-label="Close"
                    className="gdv-close"
                    onClick={() => setOpen(false)}
                >
                    &times;
                </button>
                <img
                    className="gdv-modal-content"
                    src={activeImg || specialDiscountImg}
                    alt="Special discount – everyday heroes save 20%"
                    onClick={(e) => e.stopPropagation()}
                />
            </div>,
            document.body
        );

    return (
        <section className="special-discount-section">
            {modal}

            {/* NO motion.div around the card */}
            <div className="special-discount-section-wrapper">
                <div className="glass-discount-card">
                    <div className="discount-title-wrapper">
                        <h2 className="discount-title text-warning">
                            {t("pricelist.specialDiscount")}
                        </h2>
                    </div>

                    <div className="discount-images">
                        <motion.img
                            variants={fadeUp(promps.motionOrder ?? 0)}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, margin: "-50px" }}
                            whileHover={{ scale: 1.03 }}
                            transition={{ duration: 0.25 }}
                            src={specialDiscountImg}
                            alt="Special discount – everyday heroes save 20%"
                            className="discount-img gd-pointer"
                            onClick={() => handleOpenImage(specialDiscountImg)}
                        />

                        <motion.img
                            variants={fadeUp((promps.motionOrder ?? 0) + 1)}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, margin: "-50px" }}
                            whileHover={{ scale: 1.03 }}
                            transition={{ duration: 0.25 }}
                            src={specialDiscountImg2}
                            alt="Special discount – everyday heroes save 20% (version 2)"
                            className="discount-img gd-pointer"
                            onClick={() => handleOpenImage(specialDiscountImg2)}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
